import { render, staticRenderFns } from "./HaberTanimla.vue?vue&type=template&id=e1f66682&scoped=true&"
import script from "./HaberTanimla.vue?vue&type=script&lang=js&"
export * from "./HaberTanimla.vue?vue&type=script&lang=js&"
import style0 from "./HaberTanimla.vue?vue&type=style&index=0&id=e1f66682&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1f66682",
  null
  
)

export default component.exports